import { useAsyncFn } from 'react-use';

import { useContextSelector } from 'use-context-selector';
import { emailPasswordSignIn } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';

import { ISignInRequest } from '../../types/dto.types';
import { AuthContext } from '../../contexts/Auth.context';

export const useSignIn = () => {
  const responseErrorInterceptor = useContextSelector(
    AuthContext,
    ({ responseErrorInterceptor }) => responseErrorInterceptor
  );

  return useAsyncFn(async ({ email, password }: ISignInRequest) => {
    try {
      const response = await emailPasswordSignIn({
        formFields: [
          {
            id: 'email',
            value: email,
          },
          {
            id: 'password',
            value: password,
          },
        ],
      });
      if (response.status === 'OK') {
        return response.user;
      }
      if (response.status === 'FIELD_ERROR') {
        throw new Error('Something went wrong');
      }
      if (response.status === 'WRONG_CREDENTIALS_ERROR') {
        throw new Error('Invalid username or password');
      }
    } catch (error) {
      if (error instanceof Error) {
        responseErrorInterceptor(error);
      }
      throw error;
    }
  });
};
